import React, { Component } from 'react'
import styled, {keyframes} from 'styled-components';
import media from '../../theme/media';
import { LinkCustom } from '../../theme/typography';
import { fontMono } from '../../theme/config';
import { ContainerLarge } from '../../theme/grid';

const bars = keyframes`
  from {
    top: -100%;
    height: 100%;
  }
  50% {
    height: 100%;
  }
  to {
    top: 100%;
    height: 0;
  }
`;

const dash = keyframes`
  to { stroke-dashoffset: 0; }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 20%, 0);
    transform: translate3d(0, 20%, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`;

const fadeInText = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(0, 20%, 0);
    transform: translate3d(0, 20%, 0);
    box-shadow: 0 0 0 #CED4DA;
  }

  25% {
    opacity: 0;
  }

  98% {
    box-shadow: 0 1px 0 #CED4DA;
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    box-shadow: 0 1px 0 #CED4DA;
  }
`;

const HomeContainer = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;

  ${media.tablet`
    padding: 4rem 0;
    display: block;
  `}
`;

const HomeTextContainer = styled.div`
    max-width: 28rem;
`;

const HomeHeader = styled.div`
    margin-bottom: 4rem;

    svg {
        height: 32px;
        margin-bottom: 2rem;
        margin-left: -18px;

        .animate-m {
          stroke-dasharray: 320;
          stroke-dashoffset: 320;
          animation: ${dash} .64s linear forwards;
          animation-delay: .2s;
        }
        .animate-i {
          stroke-dasharray: 10;
          stroke-dashoffset: 10;
          animation: ${dash} .02s linear forwards;
          animation-delay: 1.06s;
        }
        .animate-k {
          stroke-dasharray: 110;
          stroke-dashoffset: 110;
          animation: ${dash} .22s linear forwards;
          animation-delay: .84s;
        }
    }

    p {
      opacity: 0;
      animation: ${fadeIn} .5s linear forwards;
      animation-delay: .2s;
    }

    ${media.phone`
        svg {
            height: 32px;
            margin: 0 0 1rem -0.5rem;
        }
        margin-bottom: 2rem;
    `}
`;

const HomeLinks = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 2rem;
    ${media.phone`
        display: block;
    `}
`;

const HomeList = styled.ul`
  list-style-type: none;
  padding-bottom: 40px;
  width: fit-content;
  font-size: 16px;
  line-height: 24px;
  animation: ${fadeIn} .5s linear forwards;
  opacity: 0;

  &:nth-child(1) {
    animation-delay: .25s;
    li a:before {
      animation: ${bars} .5s linear forwards;
      animation-delay: .5s;
    }
    li a {
      opacity: 0;
      animation: ${fadeInText} .5s linear forwards;
      animation-delay: .5s;
      border: none;
      box-shadow: 0 1px 0 #CED4DA;
      line-height: 28px;
    }
  }
  &:nth-child(2) {
    animation-delay: .5s;
    li a:before {
      animation: ${bars} .5s linear forwards;
      animation-delay: .75s;
    }
    li a {
      opacity: 0;
      animation: ${fadeInText} .5s linear forwards;
      animation-delay: .75s;
      border: none;
      box-shadow: 0 1px 0 #CED4DA;
      line-height: 28px;
    }
  }
  &:nth-child(3) {
    animation-delay: .75s;
    li a:before {
      animation: ${bars} .5s linear forwards;
      animation-delay: 1s;
    }
    li a {
      opacity: 0;
      animation: ${fadeInText} .5s linear forwards;
      animation-delay: 1s;
      border: none;
      box-shadow: 0 1px 0 #CED4DA;
      line-height: 28px;
    }
  }
  &:nth-child(4) {
    animation-delay: 1s;
    li a:before {
      animation: ${bars} .5s linear forwards;
      animation-delay: 1.25s;
    }
    li a {
      opacity: 0;
      animation: ${fadeInText} .5s linear forwards;
      animation-delay: 1.25s;
      border: none;
      box-shadow: 0 1px 0 #CED4DA;
      line-height: 28px;
    }
  }
  &:nth-child(5) {
    animation-delay: 1.25s;
    li a:before {
      animation: ${bars} .5s linear forwards;
      animation-delay: 1.5s;
    }
    li a {
      opacity: 0;
      animation: ${fadeInText} .5s linear forwards;
      animation-delay: 1.5s;
      border: none;
      box-shadow: 0 1px 0 #CED4DA;
      line-height: 28px;
    }
  }
  &:nth-child(6) {
    animation-delay: 1.5s;
    li a:before {
      animation: ${bars} .5s linear forwards;
      animation-delay: 1.75s;
    }
    li a {
      opacity: 0;
      animation: ${fadeInText} .5s linear forwards;
      animation-delay: 1.75s;
      border: none;
      box-shadow: 0 1px 0 #CED4DA;
      line-height: 28px;
    }
  }

  &:last-child {
    padding-bottom: 0;
  }
  li a:before {
    content: '';
    position: absolute;
    top: 22%;
    height: 80%;
    background: #ecf2f8;
    width: 100%;
  }
  li b {
    font-family: "IBM Plex Mono",-apple-system,BlinkMacSystemFont,San Francisco,Segoe UI,sans-serif;
    margin-bottom: 4px;
    display: inline-block;
    color: #1E1F21;
    ${media.tablet`
      margin-bottom: 0;
    `}
  }
  ${media.tablet`
    margin: 0;
    padding-bottom: 32px;
    line-height: 28px;
  `}
`;

const HomeImgContainer = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 50%;
    max-width: 720px;
    text-align: center;
    ${media.tablet`
      position: initial;
      width: 100%;
      height: auto;
      min-width: 0;
      img {
        display: none;
      }
      img:last-child {
        display: block;
      }
    `}
`;

const HomeImgContainerContainer = styled.div`
    position: relative;
    height: fit-content;
    width: 100%;
`;

const HomeImg = styled.div`
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    opacity: 0;
    ${media.tablet`
      height: auto;
      opacity: 1;
      &.skwizIllo, .skwiz2Illo, &.mozillaIllo, &.mozilla2Illo, &.everyactionIllo, &.everyaction2Illo, &.amazonIllo, &.amazon2Illo, &.contact2Illo {
        display: none;
      }
      .backgroundImage {
        display: none;
      }
    `}
`;

const SkwizIllo = styled.img`
    width: 40%;
    right: 30%;
    top: 39.5%;
    height: auto;
    position: absolute;
    ${media.tablet`
      display: none;
    `}
`;

const Skwiz2Illo = styled.img`
    width: 240px;
    right: -90px;
    bottom: 120px;
    height: auto;
    position: absolute;
    ${media.tablet`
      display: none;
    `}
`;

const Skwiz3Illo = styled.img`
    position: absolute;
    width: 100px;
    height: 100px;
    left: -50px;
    top: 220px;
    ${media.tablet`
      display: none;
    `}
`;

const Amazon2Illo = styled.img`
    position: absolute;
    width: 100px;
    height: 100px;
    left: -50px;
    top: 220px;
    ${media.tablet`
      display: none;
    `}
`;


const MozillaIllo = styled.img`
    height: auto;
    position: absolute;
    width: 400px;
    right: -248px;
    bottom: 0;
    ${media.tablet`
      display: none;
    `}
`;

const Mozilla2Illo = styled.img`
    height: auto;
    position: absolute;
    width: 400px;
    left: -56px;
    bottom: 100px;
    ${media.tablet`
      display: none;
    `}
`;

const EveryactionIllo = styled.img`
right: -44px;
top: 172px;
    width: 120px;
    height: auto;
    position: absolute;
    ${media.tablet`
      display: none;
    `}
`;

const AmazonIllo = styled.img`
    left: 0;
    top: 0;
    position: absolute;
    width: 100%;
    height: auto;
    ${media.tablet`
      display: none;
    `}
`;

const Everyaction2Illo = styled.img`
    bottom: 62px;
    left: 31px;
    width: 120px;
    height: auto;
    position: absolute;
    ${media.tablet`
      display: none;
    `}
`;

const ContactIllo = styled.img`
    width: 200px;
    height: auto;
    position: absolute;
    right: 2%;
    top: 37%;
    ${media.tablet`
      display: block;
      opacity: 1;
      width: 100%;
      max-width: 400px;
      position: initial;
      padding: 0 2rem;
    `}
`;

const Contact2Illo = styled.img`
    width: 200px;
    height: auto;
    position: absolute;
    left: 24px;
    bottom: 280px;
    ${media.tablet`
      display: none;
    `}
`;

export default class Home extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {
      linkLabel: 'Read More',
      displayImage: 'default'
    }

    this.onSkwizMouseEnterHandler = this.onSkwizMouseEnterHandler.bind(this);
    this.onSkwiz2MouseEnterHandler = this.onSkwiz2MouseEnterHandler.bind(this);
    this.onAmazonMouseEnterHandler = this.onAmazonMouseEnterHandler.bind(this);
    this.onAmazon2MouseEnterHandler = this.onAmazon2MouseEnterHandler.bind(this);
    this.onMozillaMouseEnterHandler = this.onMozillaMouseEnterHandler.bind(this);
    this.onMozilla2MouseEnterHandler = this.onMozilla2MouseEnterHandler.bind(this);
    this.onEveryActionMouseEnterHandler = this.onEveryActionMouseEnterHandler.bind(this);
    this.onEveryAction2MouseEnterHandler = this.onEveryAction2MouseEnterHandler.bind(this);
    this.onContactMouseEnterHandler = this.onContactMouseEnterHandler.bind(this);
    this.onContact2MouseEnterHandler = this.onContact2MouseEnterHandler.bind(this);
    this.onMouseOutHandler = this.onMouseOutHandler.bind(this);
  }

  onSkwizMouseEnterHandler(event) {
    this.setState({
      displayImage: 'skwizImage'
    });
  }

  onSkwiz2MouseEnterHandler(event) {
    this.setState({
      displayImage: 'skwiz2Image'
    });
  }

  onAmazonMouseEnterHandler(event) {
    this.setState({
      displayImage: 'amazonImage'
    });
  }

  onAmazon2MouseEnterHandler(event) {
    this.setState({
      displayImage: 'amazon2Image'
    });
  }

  onMozillaMouseEnterHandler(event) {
    this.setState({
      displayImage: 'mozillaImage'
    });
  }

  onMozilla2MouseEnterHandler(event) {
    this.setState({
      displayImage: 'mozilla2Image'
    });
  }

  onEveryActionMouseEnterHandler(event) {
    this.setState({
      displayImage: 'everyactionImage'
    });
  }

  onEveryAction2MouseEnterHandler(event) {
    this.setState({
      displayImage: 'everyaction2Image'
    });
  }

  onContactMouseEnterHandler(event) {
    this.setState({
      displayImage: 'contactImage'
    });
  }

  onContact2MouseEnterHandler(event) {
    this.setState({
      displayImage: 'contact2Image'
    });
  }

  onMouseOutHandler(event) {
    this.setState({
      displayImage: 'default'
    });
  }

  render() {

    return (
          <ContainerLarge>
              <HomeContainer>
                  <HomeTextContainer>
                      <HomeHeader>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 168 48">
                              <g fill="none" fill-rule="evenodd" stroke="#000" stroke-linecap="round" stroke-width="3.40909091">
                                  <path className="animate-m" stroke-linejoin="round" d="M3 21.2034632C51-2.93217893 61.6515152-.32611833 34.9545455 29.021645c-40.04545459 44.021645 61.4545454-42.9545454 27.3636363-.6818182-34.0909091 42.2727273 38.8636364-27.27272723 20.4545455 0C70.5 46.521645 76.8636364 46.9761905 101.8636364 29.7034632c-4.1232207 12.043835-3.4414025 15.4392526 2.0454546 10.1862528 5.486857-5.2529999 12.305039-15.8287574 20.454545-31.72727275"></path>
                                  <path className="animate-i" d="M103.909091 23.1624432l2.045454-4.090909"></path>
                                  <path className="animate-k" stroke-linejoin="round" d="M125.090909 25.2078978C116 31 105.318182 34.7533523 113.5 40.889716 121.681818 47.0260796 149 33 137 32s-10 21 27 4"></path>
                              </g>
                          </svg>
                          <p>Michael McCombie is a designer, developer, & animator. He co-founded the production studio jERKS iNC. and co-created the collaborative drawing app Skwiz.</p>
                      </HomeHeader>
                      <HomeLinks>
                          <div>
                            <HomeList id="amazon">
                                <li><b>Amazon</b></li>
                                <li onMouseEnter={this.onAmazon2MouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="amazon" href="/amazon-data-plugin">Data Plugin</LinkCustom></li>
                                <li onMouseEnter={this.onAmazonMouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="amazon" href="/amazon-review-plugin">Review Plugin</LinkCustom></li>
                            </HomeList>
                            <HomeList id="everyaction">
                                <li><b>EveryAction</b></li>
                                <li onMouseEnter={this.onEveryActionMouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="everyaction" href="/everyaction-design-system">Design System</LinkCustom></li>
                                <li onMouseEnter={this.onEveryAction2MouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="everyaction" href="/everyaction-components">Components</LinkCustom></li>
                            </HomeList>
                          </div>
                      	<div>
                          {/*<HomeList id="skwiz">
                              <li><b>Skwiz</b></li>
                              <li onMouseEnter={this.onSkwizMouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="skwiz" href="/skwiz-drawing-game">Drawing Game</LinkCustom></li>
                              <li onMouseEnter={this.onSkwiz2MouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="skwiz" href="/skwiz-colors">Color Palettes</LinkCustom></li>
                          </HomeList>*/}
                          <HomeList id="mozilla">
                              <li><b>Mozilla</b></li>
                              <li onMouseEnter={this.onMozilla2MouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="mozilla" href="/mozilla-design-tokens">Design Tokens</LinkCustom></li>
                              <li onMouseEnter={this.onMozillaMouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom className="mozilla" href="/mozilla-component-editor">Component Editor</LinkCustom></li>
                          </HomeList>
                          <HomeList id="contact">
                              <li><b>Misc.</b></li>
                              <li onMouseEnter={this.onContact2MouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom href="/about">About</LinkCustom></li>
                              <li onMouseEnter={this.onContactMouseEnterHandler} onMouseLeave={this.onMouseOutHandler}><LinkCustom href="mailto:mvmccombie@gmail.com">Email</LinkCustom></li>
                          </HomeList>
                        </div>

                      </HomeLinks>
                  </HomeTextContainer>

                  <HomeImgContainer className={this.state.displayImage}>
                      {/*<HomeImg className="skwizIllo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/skwiz@2x.png')} />
                              <SkwizIllo alt="" src={require('../../assets/Home/skwiz-logotype.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="skwiz2Illo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/skwiz2@2x.png')} />
                              <Skwiz2Illo alt="" src={require('../../assets/Home/skwiz-color.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>*/}
                      <HomeImg className="amazonIllo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/amazon-review.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="amazon2Illo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/amazon-import.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="mozilla2Illo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/mozilla-icons.gif')} />
                              <Mozilla2Illo alt="" src={require('../../assets/Home/mozilla2.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="mozillaIllo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/mozilla@2x.png')} />
                              <MozillaIllo alt="" src={require('../../assets/Home/mozilla-construction.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="everyactionIllo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/everyaction2@2x.png')} />
                              <EveryactionIllo alt="" src={require('../../assets/Home/everyaction.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="everyaction2Illo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/everyaction-components@2x.gif')} />
                              <Everyaction2Illo alt="" src={require('../../assets/ProgressComponents/hillary-grid@2x.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="contact2Illo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/contact2@2x.png')} />
                              <Contact2Illo alt="" src={require('../../assets/Home/sleeping.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                      <HomeImg className="contactIllo">
                          <HomeImgContainerContainer>
                              <img className="backgroundImage" alt="" src={require('../../assets/Home/contact@2x.png')} />
                              <ContactIllo alt="" src={require('../../assets/Home/contact.gif')} />
                          </HomeImgContainerContainer>
                      </HomeImg>
                  </HomeImgContainer>
              </HomeContainer>
          </ContainerLarge>
    );
  }
}



// WEBPACK FOOTER //
// src/containers/Home/Home.js